import type { IImportRowError } from "@/providers/store/api/schools/schools.interface";

export enum StudentImportType {
  FALL_SNAPSHOT = "FALL_SNAPSHOT",
  MONTHLY = "MONTHLY",
}

export interface ICreateStudentUploadUrlRequest {
  filename: string;
  mimetype: string;
  size: number;
  districtId: string;
}

export interface IStudentUploadUrlResponse {
  fileId: string;
  uploadUrl: string;
  expiresIn: number;
}

export interface IImportStudentListRequest {
  fileId: string;
  districtId: string;
  type: StudentImportType;
}

export interface IStudentFileInfo {
  id: string;
  name: string;
  url: string;
}

export interface IStudentGradeAggregate {
  grade: string;
  gradeCode?: number;
  count: number;
}

export interface IImportStudentListResponse {
  studentDataImportId: string;
  totalRows: number;
  /** Rows that passed validation; student rows are created when finalizing */
  validatedRowCount: number;
  errorCount: number;
  errors?: IImportRowError[];
  file: IStudentFileInfo;
  processedAt: string;
  uploadedGradeAggregates: IStudentGradeAggregate[];
}

export interface IGetStudentAdjacentGradeAggregatesRequest {
  districtId: string;
  importType: StudentImportType;
  year: number;
  month?: number;
}

export interface IStudentAdjacentGradeAggregatesResponse {
  previous: IStudentGradeAggregate[];
  following: IStudentGradeAggregate[];
}

export interface IFinalizeStudentDataImportRequest {
  year: number;
  month?: number;
  documentName: string;
}

export interface IFinalizeStudentDataImportResponse {
  id: string;
  districtId: string;
  documentId: string;
  year: number;
  month: number | null;
  type: string;
  documentName: string;
  isActive: boolean;
  processedAt: string;
  updatedAt: string;
}

export interface IStudentResponse {
  id: string;
  studentId: string;
  firstName: string;
  middleName: string | null;
  lastName: string;
  grade: string;
  districtOfResidence: string | null;
  isNewToDistrict: boolean;
  isELL: boolean;
  isSPED: boolean;
  is504: boolean;
  isIEP: boolean;
  isFreeReducedLunch: boolean;
  isFosterCare: boolean;
  isHomeless: boolean;
  createdAt: string;
  updatedAt: string;
}

export type OtherInfoItem = {
  type: "badge" | "keyValue";
  label: string;
  value?: string;
};

export interface IStudentWithDetailsResponse {
  student: IStudentResponse;
  fullName: string;
  address: string | null;
  attendingSchoolName: string | null;
  residenceSchoolESName: string | null;
  residenceSchoolMSName: string | null;
  residenceSchoolHSName: string | null;
  engLangLearnerValue: string | null;
  dualImmersionValue: string | null;
  raceAndEthnicity: string[];
  otherInfo: OtherInfoItem[];
}

